<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Warehouse Passed Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block"
    >
      <div class="row">
        <preDatatableComponent
          :permissions="{}"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity: 0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td>{{ r.theOrderID }}</td>
                <!-- <td>
                  <display-branch :data="r" />
                </td> -->
                <td class="ws-nowrap">
                  {{ r.full_name }}
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }}
                </td>
                <td>{{ r.note }}</td>
                <td
                  style="min-width: 130px"
                  class="date-container"
                >
                  <view-order-dates :orderData="r" />
                </td>
                <td>{{ r.warehouse_date }}</td>
                <td>{{ r.bank_name }}</td>
                <td
                  v-if="$_has_perm('view_order_detail')"
                  style="padding-left: 10px; padding-right: 5px"
                >
                  <a
                    style="color: #01579b"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            :isOrder="true"
            v-if="isMobile"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.theOrderID }} , <br />
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  Quantity: {{ r.quantity }}
                </td>
                <td>
                  Customer ID: {{ r.user_id }} , <br />
                  Name: {{ r.full_name }} , <br />
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span> <br />
                  <a
                    v-if="$_has_perm('view_order_detail')"
                    style="color: #01579b; display: inline-block; padding-right: 3px"
                    tooltip="View Details"
                    @click="initDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  > No Results Found </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <view-log-details
            :detialData="detialData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-log-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import mobileDatatable from './mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'
import viewLogDetails from './logs/viewLogDetails.vue'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'mobile-datatable': mobileDatatable,
    'view-log-details': viewLogDetails
  },
  mounted() {
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: '', name: '', text: 'Check box', value: '1' },
      {
        label: 'OrderID',
        text: 'OrderID',
        value: '2',
        sortable: true,
        searchable: true,
        name: 'theOrderID'
      },
      // {
      //   label: 'Branches',
      //   text: 'Branches',
      //   value: '3',
      //   sortable: false,
      //   searchable: false,
      //   name: 'branches'
      // },
      {
        label: 'Customer Name',
        text: 'Customer Name',
        value: '3',
        sortable: true,
        searchable: true,
        name: 'full_name'
      },
      {
        label: 'Product URL',
        text: 'Product URL',
        value: '4',
        sortable: true,
        searchable: true,
        name: 'product_url'
      },
      {
        label: 'Product Name',
        text: 'Product Name',
        value: '5',
        sortable: true,
        searchable: true,
        name: 'product_name'
      },
      {
        label: 'Quantity',
        text: 'Quantity',
        value: '6',
        sortable: true,
        searchable: true,
        name: 'quantity'
      },
      {
        label: 'Warehouse',
        text: 'Warehouse',
        value: '7',
        sortable: true,
        searchable: true,
        name: 'country'
      },
      {
        label: 'Order Note',
        text: 'Order Note',
        value: '8',
        sortable: true,
        searchable: true,
        name: 'note'
      },
      {
        label: 'Date',
        text: 'Date',
        value: '9',
        sortable: true,
        searchable: true,
        name: 'order_date'
      },
      {
        label: 'Warehouse Date',
        text: 'Warehouse Date',
        value: '10',
        sortable: true,
        searchable: true,
        name: 'warehouse_date'
      },
      {
        label: 'Bank',
        text: 'Bank',
        value: '11',
        sortable: true,
        searchable: true,
        name: 'bank_name',
      },
    ]
    columns.forEach((column) => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      isMobile: false,
      loadSingleApprove: false,
      approveValue: '1',
      loading: false,
      url: 'api/warehouse_date_passed',
      orderDetailUrl: 'api/show_order_detail',
      alertValue: false,
      checkAlert: false,
      filterMade: false,
      orderIds: [],
      totalResult: 0,
      queryParameter: true,
      cancelData: {
        cancel_reason: ''
      },
      companyUrl: 'api/company_info',
      detialData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      updateData: {
        item_price: '',
        tax: '',
        item_weight: '',
        kreenex_fee: '',
        insurance: '',
        total_amount: '',
        estimated_time: ''
      },
      btnsave: true,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'order_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    checkAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if (!$('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    unCheckAll() {
      for (let i = 0; i < this.apiResults.length; i++) {
        if ($('#cb' + i).is(':checked')) {
          $('#cb' + i).click()
        }
      }
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.companyData = response.data.data
        })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }

          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch((errors) => { })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.detialData = response.data.data[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

.has-error .select2-selection--single:not([class*='bg-']):not([class*='border-']) {
  border-bottom-color: red;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseDatePassed.vue